export default {
    START: 0,
    STEP1: 1,
    CONFIRMATION: 2
};
